import { components } from './components';
import { palette } from './palette';
import { shadows } from './shadows';
import { shape } from './shape';
import { typography } from './typography';
export var theme = {
    spacing: 8,
    components: components,
    palette: palette,
    shadows: shadows,
    shape: shape,
    typography: typography,
};
